import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavigationConstant} from '@constant/navigation.constant';
import {RequestHelper} from '@helper/request.helper';
import {environment} from '@environments/environment';
import {APIConstant} from '@constant/api.constant';

@Component({
  selector: 'app-payment-shopeepay',
  templateUrl: './payment-shopeepay.component.html',
  styleUrls: ['./payment-shopeepay.component.css']
})
export class PaymentShopeepayComponent implements OnInit {

  invoiceNumber;
  amount;
  pin;
  isSubmitted;
  isLoading;
  form: FormGroup;
  paymentStatus;
  invalidPin = false;
  merchantExtId;
  storeExtId;
  payment: Payment;
  returnUrl;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private apiService: RequestHelper) { }

  ngOnInit(): void {
    this.form = new FormBuilder().group({
      pin: [null, Validators.required]
    });
    this.route.queryParams
        .subscribe(params => {
              this.payment = new Payment();
              console.log(params); // { orderby: "price" }
              this.payment.reference_id = params.invoiceNumber;
              this.payment.payment_reference_id = params.invoiceNumber;
              this.payment.amount = Number(params.amount);
              this.payment.merchant_ext_id = params.mei;
              this.payment.store_ext_id = params.sei;
              this.invoiceNumber = params.invoiceNumber;
              this.amount = params.amount;
              this.returnUrl = params.returnUrl;
              console.log(this.invoiceNumber); // price
              console.log(this.amount); // price
            }
        );
  }

  submitPayment() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }

    if (this.pin === '123456') {
        this.paymentStatus = 'success';
        this.payment.payment_status = 1;


        this.apiService
            .post(environment.walletApiUrl + APIConstant.SHOPEEPAY_PAYMENT, JSON.stringify(this.payment))
            .subscribe((data) => {
            this.router.navigateByUrl(NavigationConstant.SHOPEEPAY_PAYMENT_RESULT, {
                state: {paymentStatus: this.paymentStatus, data, payment: this.payment, returnUrl: this.returnUrl }
            });
            }, (err) => {
                this.isLoading = false;
            }
        );


    } else if (this.pin === '111111') {
        this.payment.payment_status = 6;
        this.apiService
            .post(environment.walletApiUrl + APIConstant.SHOPEEPAY_PAYMENT, JSON.stringify(this.payment))
            .subscribe((data) => {
                    this.router.navigateByUrl(NavigationConstant.SHOPEEPAY_PAYMENT_RESULT, {
                        state: {paymentStatus: this.paymentStatus, data, payment: this.payment, returnUrl: this.returnUrl }
                    });
                }, (err) => {
                    this.isLoading = false;
                }
            );

    } else {
        this.invalidPin = true;
    }


    this.isLoading = true;
    // this.apiService.post('url ShopeePay', 'params').subscribe((data) => {
    // }, () => this.isLoading = false);
  }

  goHowToUse() {
    this.router.navigate([NavigationConstant.HOME]);
  }

    invalidPinFalse() {
      this.invalidPin = false;
    }
}

class Payment {
    payment_reference_id: string;
    amount: number;
    merchant_ext_id: string;
    store_ext_id: string;
    payment_status: number;
    reference_id: string;

}
